import { render, staticRenderFns } from "./OrdersWrapper.vue?vue&type=template&id=783249eb&"
import script from "./OrdersWrapper.vue?vue&type=script&lang=js&"
export * from "./OrdersWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports